import { redirectWithGet } from '../../../shared/api/redirect/redirect.js';

export function redirectCommonPwd({ user = '', domain = '', group = '', custom = '', notificationLock = '', lang = '' }) {
  const urlSearchParams = new URLSearchParams({
    user,
    domain,
    group,
    custom,
    notificationLock,
    lang,
  });
  return redirectWithGet(`/login?${urlSearchParams}`);
}
